import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4ceefe1c&"
import script from "./edit.js?vue&type=script&lang=js&"
export * from "./edit.js?vue&type=script&lang=js&"
import style0 from "./edit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports